<template>
    <div class=text-page>

        <RichTextPopup :isActive="true" :content="post.content.rendered" :blocks="post.acf.content_blocks || []" @close-popup="back" />

    </div>
</template>
<script>
import RichTextPopup from '../components/RichTextPopup.vue';

export default {
    name : 'RichTextPage',
    props : {
        post     : Object,
    },
    components : {
        RichTextPopup,
    },
    methods : {
        back() {
            this.$router.push({ name : this.$route.meta.parent });
        }
    },


}
</script>